window.onload = function () {
    const checkElementsExist = setInterval(() => {
      const productCards = document.querySelectorAll(".cbb-also-bought-product");
  
      if (productCards.length === 0) return; // Wait until product cards are available
  
      productCards.forEach(card => {
        const titleElement = card.querySelector(".cbb-also-bought-product-name a");
        const productTitle = titleElement ? titleElement.innerText.trim() : "";
  
        let conditionText = "New";  // Default condition
  
        if (productTitle.toLowerCase().includes("open box")) {
          conditionText = "Open Box";
        } else if (productTitle.toLowerCase().includes("refurbished")) {
          conditionText = "Refurbished";
        } else if (productTitle.toLowerCase().includes("store demo")) {
          conditionText = "Store Demo";
        } else if (productTitle.toLowerCase().includes("b-stock")) {
          conditionText = "B-Stock";
        } else if (productTitle.toLowerCase().includes("customer return")) {
          conditionText = "Customer Return";
        } else if (productTitle.toLowerCase().includes("used trade-in")) {
          conditionText = "Used Trade-In";
        } else if (productTitle.toLowerCase().includes("used")) {
          conditionText = "Used";
        } else if (productTitle.toLowerCase().includes("scratch and dent")) {
          conditionText = "Scratch and Dent";
        } else if (productTitle.toLowerCase().includes("pre loved")) {
          conditionText = "Pre Loved";
        }
  
        const textDiv = document.createElement("div");
        textDiv.className = "custom-condition-text";
        textDiv.textContent = `${conditionText}`;
  
        const wrapperDiv = document.createElement("div");
        wrapperDiv.className = "product-wrapper";
        card.parentNode.insertBefore(wrapperDiv, card);
        wrapperDiv.appendChild(card);
        wrapperDiv.appendChild(textDiv);
      });
  
      // Clear interval after the elements have been processed
      clearInterval(checkElementsExist);
    }, 500); // Check every 500ms until elements are found
  };
  